import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect() {
    super.connect()

    const options = {
      container: this.element.dataset.bsContainer || 'body',
      html: true,
      placement: this.element.dataset.bsPlacement || 'top',
      customClass: this.element.dataset.bsCustomClass || '',
      trigger: this.element.dataset.bsTrigger || 'focus',
      content: this.element.dataset.bsContent || ''
    }

    this.popover = new window.bootstrap.Popover(this.element, options)
  }

  disconnect() {
    if (this.popover) {
      this.popover.dispose()
    }
  }
}
